import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Add a team member
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestAddTeamMember = packet => {
  return {
    type: 'REQUEST_ADD_TEAM_MEMBER',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveAddTeamMemberSuccess = data => ({
  type: 'RECEIVE_ADD_TEAM_MEMBER_SUCCESS',
  data
})

export const receiveAddTeamMemberFail = data => ({
  type: 'RECEIVE_ADD_TEAM_MEMBER_FAIL',
  data
})

export const tryToAddTeamMember = packet => (dispatch, getState) => {

  dispatch(requestAddTeamMember(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;
  return fetch('/api/members/' + packet.kind + '/' + packet.id, {
      method: 'post',
      body: JSON.stringify(packet),
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveAddTeamMemberSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveAddTeamMemberFail({errors:e, lastSubmit: packet}));
    })
}
